<template>
  <div
    id="contact"
    style="background: url(../static/contact.jpg) center center"
  >
    <div class="row" style="padding-top: 100px;">
      <div class="col-md-2"></div>
      <div class="col-md-8">
        <section>
          <div class="col-md-7 offset-md-5 col-lg-6 offset-lg-6">
            <div class="title-heading mt-5 pt-4">
              <h1 class="heading">{{ locale("Contacts") }}</h1>
              <p class="text-dark">{{ locale("Know more about us") }}</p>
              <!-- Email -->
              <div class="contact-detail align-items-center mt-3 media">
                <div class="icon">
                  <i>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-mail fea icon-m-md text-dark mr-3"
                    >
                      <g>
                        <path
                          d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                        ></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                      </g>
                    </svg>
                  </i>
                </div>
                <div class="content media-body">
                  <a class="text-primary" href="malto:contact@fertimo.com"
                    >contact@fertimo.com</a
                  >
                </div>
              </div>
              <!-- [./ End] Email -->

              <!-- [./ End] Phone -->
              <div class="contact-detail align-items-center mt-3 media">
                <div class="icon">
                  <i>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-phone fea icon-m-md text-dark mr-3"
                    >
                      <g>
                        <path
                          d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                        ></path>
                      </g>
                    </svg>
                  </i>
                </div>
                <div class="content media-body">
                  <a class="text-primary" href="tel:0322935070">0322935070</a>
                </div>
              </div>
              <!-- [./ End] Phone -->

              <!-- [./ End] Location -->
              <div class="media contact-detail align-items-center mt-3">
                <div class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="fea icon-m-md text-dark mr-3 feather feather-map-pin"
                  >
                    <path
                      d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                    ></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div class="media-body content">
                  <h4 class="title font-weight-bold mb-0">
                    {{ locale("Address") }}
                  </h4>
                  <a
                    href="https://maps.app.goo.gl/21oWiejm48ubD2Gm8"
                    class="video-play-icon text-primary"
                    >{{ locale("7 Innovations Str. Tbilisi, Georgia") }}</a
                  >
                </div>
              </div>
              <!-- [./ End] Location -->
            </div>
          </div>
        </section>
      </div>
      <div class="col-md-2"></div>
    </div>

    <footer
      class="footer_area h_footer_dark pos_footer_area security_footer_area geo_font"
      style="margin-top: 50px;"
    >
      <img class="leaf_left" src="img/pos/leaf-left.png" alt="" />
      <img class="leaf_right" src="img/pos/leaf-right.png" alt="" />
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="f_widget dark_widget company_widget">
              <a href="index.html" class="f-logo"
                ><img src="img/logo2.png" alt=""
              /></a>
              <p>{{ Lang("© 2020 Wellness Corporation, LLC") }}</p>
              <div class="f_social_icon">
                <a
                  href="https://www.facebook.com/Fertimo-111456580554500/"
                  target="_blank"
                  class="ti-facebook"
                ></a>
                <!-- <a href="#" class="ti-youtube"></a> -->
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="f_widget dark_widget about-widget pl_20 geo_font">
              <h3 class="f-title f_500 t_color f_size_18 mb_40">
                {{ Lang("Useful Links") }}
              </h3>
              <ul class="list-unstyled f_list geo_font">
                <li>
                  <a class="geo_font" href="#">{{ Lang("Company") }}</a>
                </li>
                <li>
                  <a class="geo_font" href="#">{{ Lang("Blog") }}</a>
                </li>
                <li>
                  <a class="geo_font" href="#">{{ Lang("Partners") }}</a>
                </li>
                <li>
                  <a class="geo_font" href="#">{{ Lang("Careers") }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 geo_font">
            <div class="f_widget dark_widget about-widget pl_20 geo_font">
              <h3 class="f-title f_500 t_color f_size_18 mb_40 ">
                {{ Lang("Help") }}
              </h3>
              <ul class="list-unstyled f_list geo_font">
                <li>
                  <a class="geo_font" href="#">{{ Lang("FAQ") }}</a>
                </li>
                <li>
                  <router-link class="geo_font" v-bind:to="'terms'">{{
                    Lang("Term & conditions")
                  }}</router-link>
                </li>
                <li>
                  <a class="geo_font" href="#">{{ Lang("Reporting") }}</a>
                </li>
                <li>
                  <a class="geo_font" href="#">{{ Lang("Pricing") }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-md-6">
            <div class="f_widget dark_widget about-widget pl_20">
              <h3 class="f-title f_500 t_color f_size_18 mb_40">
                {{ Lang("Contact") }}
              </h3>
              <ul class="list-unstyled f_list">
                <li>
                  <router-link class="geo_font" v-bind:to="'contact'">{{
                    Lang("Contact")
                  }}</router-link>
                </li>

                <li>
                  <a class="geo_font" href="#">{{ Lang("Support") }}</a>
                </li>
                <li>
                  <a class="geo_font" href="#">{{ Lang("Sales") }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          class="pos_footer_bottom justify-content-between d-flex align-items-end"
        >
          <img class="pos_women" src="img/pos/women.png" alt="" />
          <img src="img/pos/people.png" alt="" />
          <img class="pos_women" src="img/pos/man.png" alt="" />
        </div>
      </div>
      <svg class="wave_shap" xmlns="https://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          opacity="0.302"
          fill="rgb(73, 69, 140)"
          d="M22.990,11.999 C22.990,11.999 -62.334,196.188 102.000,90.998 C236.033,5.204 349.217,18.152 512.000,80.998 C773.380,181.909 898.075,49.752 1051.000,15.998 C1316.369,-42.574 1488.518,78.268 1581.000,112.999 C1783.485,189.036 1942.990,61.999 1942.990,61.999 L1942.990,211.999 L22.990,211.999 L22.990,11.999 Z"
        />
      </svg>
    </footer>
  </div>
</template>
<script>
import Vue from "vue";
import Langs from "@/mixins/Lang.js";
import locale from "@/mixins/locale.js";
export default Vue.extend({
  name: "HomePage",
  mixins: [Langs, locale],
  data: function() {
    return {};
  },
  mounted: function() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {}
});
</script>



// WEBPACK FOOTER //
// src/components/Contact/Contact.vue